import { ErrorBoundary } from '@sentry/react';
import { DefaultLoader } from 'components/default-loader/DefaultLoader';
import { RootLogicProvider } from 'context/root/RootLogicProvider';
import type { Children } from 'models';
import { Suspense } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { FullScreenLayout } from 'widgets/layouts/full-screen-layout';

import { AppApolloProvider } from './AppApolloProvider';
import { AppPostHogProvider } from './AppPostHogProvider';

export const AppProviders = ({ children }: Children) => {
  return (
    <HelmetProvider>
      <AppPostHogProvider>
        <BrowserRouter>
          <ErrorBoundary>
            <AppApolloProvider>
              <Suspense
                fallback={
                  <FullScreenLayout>
                    <DefaultLoader />
                  </FullScreenLayout>
                }
              >
                <RootLogicProvider>{children}</RootLogicProvider>
              </Suspense>
              <ToastContainer />
            </AppApolloProvider>
          </ErrorBoundary>
        </BrowserRouter>
      </AppPostHogProvider>
    </HelmetProvider>
  );
};
